module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/manu-management-component/create-manu-management/create-manu-management.component.css
// module id = ./src/app/manu-management-component/create-manu-management/create-manu-management.component.css
// module chunks = main